import { Notification, NotificationStepStatus, NotificationType } from '@dynamik/common/clients/notification-clients';

export class ProcessDocumentNotificationToDocumentIdValueConverter {
  toView(n: Notification) {
    if (n.steps.some(x => x.status !== NotificationStepStatus.Success)) {
      return undefined;
    }
    try {
      if (!n.data || typeof n.data !== 'string' || n.data === 'undefined') {
        return undefined;
      }
      return JSON.parse(n.data)?.CorrelationId;
    } catch (error) {
      return undefined;
    }
  }
}
